export enum MaterialAmountType {
  Weight = 0,
  Percentage = 1,
}
